(function(){
'use strict';

angular.module('classy.frs').run(['$templateCache', function ($templateCache) {
  $templateCache.put('frs/shared/supporter/pages/emails/header', '<div class="fundraiser-dashboard-page_header">\n' + '  <i class="fundraiser-dashboard-page_header-icon ci ci-contact" aria-hidden="true"></i>\n' + '  <h2 class="fundraiser-dashboard-page_header-title">{{title}}</h2>\n' + '  <p class="fundraiser-dashboard-page_header-subTitle">{{subTitle}}</p>\n' + '</div>\n' + '');
}]);
})();